export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-music-player/index.js